<script>
import AddBtn from "@/components/buttons/AddBtn.vue";
import Tooltip2Vue from "@/components/Tooltip2Vue/Tooltip2Vue";
import CardInColumn from "@/components/Lego/CardInColumn.vue";
import LegoProgressBarWithCompleted from "./LegoProgressBarWithCompleted.vue";
import LoadMoreBtn from "./LoadMoreBtn.vue";
export default {
  components: {
    Tooltip2Vue,
    AddBtn,
    CardInColumn,
    LegoProgressBarWithCompleted,
    LoadMoreBtn,
  },
  props: {
    color: {
      type: String,
      default: "#ef476f",
    },
  },
  data() {
    return {
      title: "",
      collapsed: false,
    };
  },
  watch: {
    "paginatedDependents.items"(newItems) {
      if (
        newItems.length === 0 &&
        this.paginatedDependents.items.length < this.paginatedDependents.total
      ) {
        this.loadMoreDependents();
      }
    },
  },
  computed: {
    userLoggedIn() {
      return this.$store.getters.userLoggedIn;
    },
    cardId() {
      return this.$route.params.cardId;
    },
    paginatedDependents() {
      return this.$store.state.lego.card.paginatedDependents;
    },
    loadingMoreDependents() {
      return this.$store.state.lego.isLoadingDependents;
    },
  },
  methods: {
    async loadMoreDependents() {
      await this.$store.dispatch("lego/loadMoreDependents", {
        cardId: this.cardId,
      });
    },
    focusOnTooltipTitle() {
      this.$nextTick(() => {
        const input = document.querySelector("#tooltipTitle");
        input.focus();
      });
    },

    createSubCard() {
      const title = this.title.trim();
      if (title === "") return;

      const subCard = {
        title,
        LegoCardId: this.cardId,
        createdBy: this.userLoggedIn.id,
      };

      this.$store.dispatch("lego/addSubCard", subCard);
      this.title = "";
    },
    closeTooltip(close) {
      this.title = "";
      close();
    },
  },
};
</script>

<template>
  <div class="mb-4">
    <div id="subTareas">
      <div
        class="section-header item-display header"
        @click="collapsed = !collapsed"
      >
        <div>
          <span>
            <i class="fas fa-layer-group title-icon"></i>
          </span>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
          "
        >
          <span class="title-section">
            Sub tareas ({{ paginatedDependents.total || 0 }})</span
          >
          <i
            :class="[
              'fas',
              collapsed ? 'fa-chevron-down' : 'fa-chevron-up',
              'chevron-icon',
            ]"
          ></i>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div v-show="!collapsed">
        <div class="item-display">
          <LegoProgressBarWithCompleted
            :completed="paginatedDependents.completed"
            :total="paginatedDependents.total"
            class="in-right"
            :color="color"
            mode="cards"
          />
          <Tooltip2Vue position="bottom-right" class="ml-4">
            <div class="btn-shadow" @click="focusOnTooltipTitle">
              <AddBtn />
              <span>Nueva sub tarea</span>
            </div>
            <template #tooltip="{ close }">
              <div class="tp-lego-container">
                <label for="tooltipTitle">Titulo</label>
                <input
                  v-model="title"
                  id="tooltipTitle"
                  type="text"
                  class="lego-input"
                  @keydown.enter="createSubCard"
                />
                <div class="tp-controls">
                  <vs-button @click="createSubCard">Crear sub tarea</vs-button>
                  <vs-button danger @click="closeTooltip(close)"
                    >Cerrar</vs-button
                  >
                </div>
              </div>
            </template>
          </Tooltip2Vue>
        </div>
        <div class="container-dependents">
          <div
            class="subCards-container custom-scrollbar"
            id="subTareasCreadas"
          >
            <CardInColumn
              :disabledControls="true"
              tooltipPosition="bottom-end"
              class="resumenSubCard"
              v-for="subCard in paginatedDependents.items"
              :key="subCard.id"
              :card="subCard"
              :id="subCard.id"
            />
          </div>
          <div
            v-if="paginatedDependents.items.length"
            class="load-more-dependents"
          >
            <div
              class="info-dependents"
              v-b-tooltip.hover
              :title="`${paginatedDependents.items.length} de ${paginatedDependents.total} sub tareas`"
            >
              {{ paginatedDependents.items.length }}/{{
                paginatedDependents.total
              }}
            </div>
            <LoadMoreBtn
              v-if="paginatedDependents.hasMore"
              :loading="loadingMoreDependents"
              @loadMore="loadMoreDependents"
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.load-more-dependents {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1rem 0;
  width: 100%;
}

.info-dependents {
  align-self: end;
  width: fit-content;
}

.header {
  margin-bottom: 0.8rem;
}

.in-right {
  grid-column-start: 2;
}

.item-display {
  display: grid;
  grid-template-columns: 24px 1fr;
  gap: 0.5rem;
}

.title-section,
.title-icon {
  font-size: 1.1rem;
  display: flex;
  gap: 0.5rem;
}

.title-icon {
  font-size: 1.2rem;
}

.in-right {
  grid-column-start: 2;
}

.btn-shadow {
  @extend .lego-control-button;
  padding: 0.25rem 0.5rem;
  font-size: 0.9rem;
  gap: 0.25rem;
}

.tp-controls {
  display: flex;
  justify-content: flex-start;
  margin-top: 0.5rem;
  gap: 0.5rem;
}

.tp-controls > * {
  margin: 0;
}

.subCards-container {
  margin: 1rem 0;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 500px;
  gap: 0.5rem;
}

.resumenSubCard {
  background: var(--lego-dbg);
  .dark & {
    background: var(--lego-bg);
  }
  padding: 0.5rem 0.5rem 0.5rem 35px;
}
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
}
.chevron-icon {
  margin-left: 0.5rem;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
